import React from 'react';
import './Contact.css';
import { FaPhone, FaEnvelope, FaClock, FaMapMarkerAlt } from 'react-icons/fa';
import emailjs from 'emailjs-com';
import teamImg from './assets/reception.jpg'; // Image to use as banner

const ContactPage = () => {
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm(
      'service_pn5ekzn',
      'template_872zbcf',
      e.target,
      'Fuknvj-HuynYfX-2R'
    )
    .then(() => {
      alert('✅ Message sent successfully!');
      e.target.reset();
    })
    .catch(() => {
      alert('⚠️ Failed to send message. Please try again.');
    });
  };

  return (
    <div className="contact-page">

      {/* Banner Section with Overlay */}
      <div className="contact-banner">
        <img src={teamImg} alt="Reception Banner" className="contact-banner-image" />
        <div className="contact-banner-overlay">
          <h1>Get in Touch with Mwangaza Wellness and Medical Centre</h1>
          <p>
            We’re here to support your journey to better health. Reach out to us for appointments,
            inquiries, or health-related support.
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="contact-container">
        {/* Contact Form */}
        <div className="contact-form">
          <h2>Contact Form</h2>
          <form onSubmit={sendEmail}>
            <input type="text" name="name" placeholder="Full Name" required />
            <input type="email" name="email" placeholder="Email Address" required />
            <input type="text" name="title" placeholder="Subject" required />
            <textarea name="message" placeholder="Your Message" rows="5" required></textarea>
            <button type="submit">Send Message</button>
          </form>
        </div>

        {/* Contact Info */}
        <div className="contact-info">
          <h2>Our Contact Details</h2>
          <p><FaPhone /> Call: +254 792 994 876 / +254 736 002 467</p>
          <p><FaEnvelope /> Email: info@mwangaza.org</p>
          <p><FaClock /> Hours: Mon–Fri: 8:00 AM – 5:00 PM<br />Sat: 9:00 AM – 1:00 PM<br />Sun & Holidays: Closed</p>
          <p><FaMapMarkerAlt /> Location: Kiamwangi, Karatina</p>
        </div>
      </div>

      {/* Map */}
      <div className="map-section">
  <iframe
    title="Mwangaza Wellness and Medical Centre Location"
    src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3989.679824775698!2d37.13734170928955!3d-0.47739763527235957!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMMKwMjgnMzguNyJTIDM3wrAwOCcyMy43IkU!5e0!3m2!1sen!2ske!4v1750000827600!5m2!1sen!2ske"
    width="100%"
    height="300"
    style={{ border: 0 }}
    allowFullScreen=""
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
  ></iframe>
</div>


    </div>
  );
};

export default ContactPage;
